import { atom } from "recoil";
import { localStorageEffect } from "./localStorageEffect";

export interface MultiCamConfig {
  regionId: string;
  cameraIds: string[];
}

/**
 * Persisted multi-cam setup — stores which cameras were last shown in the grid.
 * Restored on page load so users can pick up where they left off.
 */
export const multiCamAtom = atom<MultiCamConfig | null>({
  key: "multiCamCameras",
  default: null,
  effects_UNSTABLE: [localStorageEffect("multiCamCameras")],
});
